import {
  ListChecks,
  CheckCircle2,
  Clock,
  Circle,
  AlertTriangle,
} from "lucide-react";

function Card({ icon: Icon, label, value, accent, testId }) {
  return (
    <div
      data-testid={testId}
      className="flex items-center gap-3 rounded-lg border border-gray-200 bg-white px-4 py-3"
    >
      <div
        className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-md ${
          accent || "bg-[#e8edf2] text-[#1e3a5f]"
        }`}
      >
        <Icon className="h-4 w-4" strokeWidth={2} />
      </div>
      <div className="min-w-0 leading-tight">
        <div className="text-[10px] font-semibold uppercase tracking-[0.12em] text-slate-500">
          {label}
        </div>
        <div className="mt-0.5 font-display text-xl font-bold text-slate-900">
          {value}
        </div>
      </div>
    </div>
  );
}

export default function SummaryCards({ summary }) {
  return (
    <div className="grid grid-cols-2 gap-3 md:grid-cols-5" data-testid="summary-cards">
      <Card
        icon={ListChecks}
        label="Total Sub-Kegiatan"
        value={summary.total}
        testId="summary-total"
      />
      <Card
        icon={CheckCircle2}
        label="Selesai"
        value={summary.selesai}
        accent="bg-emerald-50 text-emerald-700"
        testId="summary-selesai"
      />
      <Card
        icon={Clock}
        label="On Progress"
        value={summary.onProgress}
        accent="bg-blue-50 text-blue-700"
        testId="summary-on-progress"
      />
      <Card
        icon={Circle}
        label="Belum Mulai"
        value={summary.belumMulai}
        accent="bg-gray-100 text-gray-600"
        testId="summary-belum-mulai"
      />
      <Card
        icon={AlertTriangle}
        label="Terhambat"
        value={summary.terhambat}
        accent="bg-red-50 text-red-700"
        testId="summary-terhambat"
      />
    </div>
  );
}
